import { useEffect, useState } from 'react';

/**
 * Reactive isMobile hook. True when viewport width < 768px.
 */
export function useIsMobile() {
  const get = () => typeof window !== 'undefined' && window.matchMedia('(max-width: 767px)').matches;
  const [isMobile, setIsMobile] = useState(get);
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const mq = window.matchMedia('(max-width: 767px)');
    const on = () => setIsMobile(mq.matches);
    mq.addEventListener('change', on);
    return () => mq.removeEventListener('change', on);
  }, []);
  return isMobile;
}
